import axios from "axios";

const API_BASE_URL =
  import.meta.env.VITE_API_URL || "https://dashboard.lono.co.in/api";

// Create axios instance with auth token
const createAuthInstance = () => {
  const token = localStorage.getItem("token");
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

// User API Service
export const userAPI = {
  // Get all users (for conversation creation)
  getAllUsers: async (search = "", userType = "") => {
    try {
      const params = new URLSearchParams();
      if (search) params.append("search", search);
      if (userType) params.append("userType", userType);

      const response = await createAuthInstance().get(`/users?${params}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching all users:", error);
      throw error.response?.data || error.message;
    }
  },

  // Get users by type
  getUsersByType: async (userType) => {
    try {
      const response = await createAuthInstance().get(
        `/users?userType=${userType}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error fetching users by type ${userType}:`, error);
      throw error.response?.data || error.message;
    }
  },

  // Get current user profile
  getCurrentUser: async () => {
    try {
      const response = await createAuthInstance().get("/users/profile");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update user profile
  updateProfile: async (userData) => {
    try {
      const response = await createAuthInstance().put(
        "/users/profile",
        userData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get staff members
  getStaffMembers: async () => {
    try {
      const response = await createAuthInstance().get("/users?userType=staff");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get admin users
  getAdminUsers: async () => {
    try {
      const response = await createAuthInstance().get("/users?userType=admin");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get customers
  getCustomers: async () => {
    try {
      const response = await createAuthInstance().get(
        "/users?userType=customer"
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get banking partners
  getBankingPartners: async () => {
    try {
      const response = await createAuthInstance().get(
        "/users?userType=banking-partner"
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get affiliate partners
  getAffiliatePartners: async () => {
    try {
      const response = await createAuthInstance().get(
        "/users?userType=affiliate_partner"
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default userAPI;
